import { Environment, PasswordConnectionHint } from './environment.type';

export const environment: Environment = {
    NAME: 'production',
    LOGIN_URL: 'https://login.bannerflow.com',
    CLIENT_ID: 'b3tatgviNxjBh8jUMlbYOIJvMUkDmTL3',
    BANNERFLOW_CLIENT_URL: 'https://app.bannerflow.com/home',
    ACCOUNT_ACCESS_SERVICE_URL: 'https://api.bannerflow.com/account-access',
    BAU_SERVICE_URL: 'https://api.bannerflow.com/bau',
    CONNECTION_HINT_MAP: new Map<string, string>([
        [PasswordConnectionHint, 'Username-Password-Authentication'],
        ['bfg', 'bannerflow-google'],
        ['bfe', 'bannerflow-entra'],
        ['accenturejlr', 'accenture-jlr-saml'],
        ['accenturel', 'accenture-entra'],
        ['sok', 'sok-entra'],
        ['if', 'if-saml']
    ]),
    FULLSTORY_ORG_ID: 'o-CTHT-eu1',
    NEW_RELIC_ACCOUNT_ID: '4122654',
    NEW_RELIC_APPLICATION_ID: '538687566',
    NEW_RELIC_LICENSE_KEY: 'NRJS-bd28b6acdc31b77b97c',
    NEW_RELIC_TRUST_KEY: '4122654',
    RELEASE_NAME: '',
    VERSION: ''
};
